import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=9e416ed8"
import script from "./GroupsList.vue?vue&type=script&lang=js"
export * from "./GroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports